import { render, staticRenderFns } from "./CareCommunityRecord.vue?vue&type=template&id=20e0ab24&scoped=true&"
import script from "./CareCommunityRecord.vue?vue&type=script&lang=js&"
export * from "./CareCommunityRecord.vue?vue&type=script&lang=js&"
import style0 from "./CareCommunityRecord.vue?vue&type=style&index=0&id=20e0ab24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0ab24",
  null
  
)

export default component.exports